import capitalize from 'lodash/capitalize';

export function generatePlaceAmenityPhoto(details) {
    const placeAmenityPhoto = {};
    details.amenity_photos.forEach((item, i) => {
        const photo = details.amenity_photos[i];
        const place_id = photo['place_id'] || '0';
        if (placeAmenityPhoto[place_id] === undefined) {
            placeAmenityPhoto[place_id] = {};
        }
        placeAmenityPhoto[place_id][photo['amenity']] = photo['thumbnail'];
    });
    return placeAmenityPhoto;
}

export const getRate = (rates, date) => {
    const timeStamp = Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    );
    if (rates) {
        let rate = rates[0];
        for (var i = 1; i < rates.length; i++) {
            if (
                rates[i].period.from_timestamp <= timeStamp &&
                rates[i].period.to_timestamp >= timeStamp
            ) {
                rate = rates[i];
                break;
            }
        }
        return rate;
    }
};

export const getExpectationLabel = type => {
    return (
        type &&
        type
            .split('_')
            .map(item => capitalize(item))
            .join(' ')
    );
};
